'use es6';

import http from 'hub-http/clients/apiClient';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { AUTOMATION_PLATFORM_WORKFLOWS } from 'reference-resolvers/constants/CacheKeys';
import { getWorkflowsByIds, createGetWorkflowsByIds } from 'reference-resolvers/api/AutomationPlatformWorkflowsAPI';
import { makeCreateGetWorkflowsSearchPage } from 'reference-resolvers/api/AutomationPlatformWorkflowsAPI';
export const createAutomationPlatformWorkflowReferenceResolver = (options, flowObjectTypeId = null) => {
  const createFetchSearchPage = makeCreateGetWorkflowsSearchPage(flowObjectTypeId);
  return createBatchedReferenceResolver(Object.assign({
    cacheKey: AUTOMATION_PLATFORM_WORKFLOWS,
    createFetchByIds: createGetWorkflowsByIds,
    createFetchSearchPage,
    fetchByIds: getWorkflowsByIds,
    fetchSearchPage: createFetchSearchPage({
      httpClient: http
    })
  }, options));
};
export default createAutomationPlatformWorkflowReferenceResolver();